<template>
  <v-dialog v-model="value" width="600" @keydown.esc="dismiss()" persistent scrollable>
    <v-card>
      <v-card-title
        class="d-flex justify-space-between align-center blue white--text py-2">{{ $t('customer.assign_employee_permission') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="!isLoading">
        <h2>{{ $t('category_short') }}</h2>
        <div class="group">
          <div class="group-box" v-for="(label, idx) in formDataLabel" :key="`group-box-${idx}`">
            <div class="group-header"> {{ label.text }} </div>
            <div class="group-data" v-for="(inLabel, index) in  label.value" :key="`group-data-${index}`">
              <v-checkbox v-if="!inLabel.isGroupping" v-model="formData[inLabel.value]" :label="inLabel.text"
                off-icon="mdi-close-circle-outline" on-icon="mdi-check-circle-outline" hide-details />
              <div class="group-items" v-else>
                <div class="group-item item-header">
                  <v-checkbox v-model="formData[inLabel.value]" :label="inLabel.text"
                    @change="changeEnable(inLabel.value, formData[inLabel.value])" off-icon="mdi-close-circle-outline"
                    on-icon="mdi-check-circle-outline" hide-details />
                  <v-btn color="info" text @click="changeEnable(inLabel.value, true, true)">{{ $t('select_all') }}</v-btn>
                </div>
                <div class="group-item">
                  <v-checkbox v-if="!inLabel.inGroup" v-for="(inGroup, gIdx) in inLabel.groups"
                    :key="`group-item-${gIdx}`" v-model="formData[inGroup.value]" :label="inGroup.text"
                    :disabled="!formData[inLabel.value]" off-icon="mdi-close-circle-outline"
                    on-icon="mdi-check-circle-outline" hide-details />
                  <div class="in-group-item" v-else>
                    <div class="in-group-item-header">- {{ inGroup.text }}</div>
                    <v-checkbox v-if="formData.enableAppealObject && formData.enableAppealObject[inGroup.value]"
                      v-for="(inGroup2, g2Idx) in inLabel.inGroup" :key="`in-group-item-${g2Idx}`"
                      v-model="formData.enableAppealObject[inGroup.value][inGroup2.value]" :label="inGroup2.text"
                      :disabled="!formData[inLabel.value]" off-icon="mdi-close-circle-outline"
                      on-icon="mdi-check-circle-outline" hide-details />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" @click="dismiss()">{{ $t('close') }}</v-btn>
        <v-btn color="success" @click="submit()">{{ $t('confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppealLabels from "../json/appeal-data.json";
export default {
  props: {
    value: Boolean,
    employee: Object
  },
  computed: {
    formDataLabel() {
      let res = {
        tab: {
          text: this.$t('project.menu_bar'),
          value: {
            enableViewAreas: { value: 'enableViewAreas', text: this.$t('project.data_stall') },
            enableViewCustomers: { value: 'enableViewCustomers', text: this.$t('customer.customer_information') },
            enableViewAreaInterests: { value: 'enableViewAreaInterests', text: this.$t('area.area_interest') },
            enableViewBilling: { value: 'enableViewBilling', text: this.$t('market.collect_rental') },
            enableViewAccounting: { value: 'enableViewAccounting', text: this.$t('market.accounting_document') },
            enableViewReports: { value: 'enableViewReports', text: this.$t('market.summary_report') },
            enableViewIncomeExpense: { value: 'enableViewIncomeExpense', text: this.$t('market.income_expense') },
            enableViewOverall: { value: 'enableViewOverall', text: this.$t('project.analyse') },
          }
        },
        other: {
          text: this.$t('other'),
          value: {
            enableCannotCheckOut: { value: 'enableCannotCheckOut', text: this.$t('project.cannot_checkout_without_approval') },
            enableEditInvoiceAndReceipt: { value: 'enableEditInvoiceAndReceipt', text: this.$t('project.can_edit_invoice_and_receipt') },
            enableAddAccountingProduct: { value: 'enableAddAccountingProduct', text: this.$t('project.can_add_billing_list') },
            enableAddProduct: { value: 'enableAddProduct', text: this.$t('project.can_add_product') },
            enableEditTaxId: { value: 'enableEditTaxId', text: this.$t('project.can_edit_tax_id') },
            enableViewBoard: { value: 'enableViewBoard', text: this.$t('project.news_board', { name: ''}) },
            enableDigitalMeterOnOff: { value: 'enableDigitalMeterOnOff', text: this.$t('project.can_digital_meter_on_off') },
            enableDigitalMeterReset: { value: 'enableDigitalMeterReset', text: this.$t('project.can_digital_meter_reset') },
          }
        },
        project: {
          text: this.$t('project.project_level'),
          value: {
            enableViewAccountingProject: { value: 'enableViewAccountingProject', text: this.$t('project.accounting_document_level') },
            enableViewReportsProject: { value: 'enableViewReportsProject', text: this.$t('project.summary_report_level') },
          }
        },
        setting: {
          text: this.$t('setting.title'),
          value: {
            enableViewSettings: {
              value: 'enableViewSettings',
              text: this.$t('setup'),
              isGroupping: true,
              groups: {
                enableEditBillingSetting: { value: 'enableEditBillingSetting', text: this.$t('product.can_edit_invoice') },
                enableEditAreaAccountingProduct: { value: 'enableEditAreaAccountingProduct', text: this.$t('product.can_edit_billing_list') },
                enableSendApproveBillingSetting: { value: 'enableSendApproveBillingSetting', text: this.$t('task.can_send_approve_setting') },
              }
            },
          }
        },
        approve: {
          text: this.$t('product.approving'),
          value: {
            enableViewApprove: {
              value: 'enableViewApprove',
              text: this.$t('task.approve_list'),
              isGroupping: true,
              groups: {
                enableApproveAreaInterest: { value: 'enableApproveAreaInterest', text: this.$t('area.booking_area') },
                enableApproveSettingBilling: { value: 'enableApproveSettingBilling', text: this.$t('setting.invoice_setting') },
                enableApproveSettingAreaAccounting: { value: 'enableApproveSettingAreaAccounting', text: this.$t('setting.area_accounting_product_setting') },
                enableApproveCheckout: { value: 'enableApproveCheckout', text: this.$t('customer.seller_checkout') },
              }
            },
          }
        },
        appeal: {
          text: this.$t('appeal_data.notify'),
          value: {
            enableViewAppeal: {
              value: 'enableViewAppeal',
              text: this.$t('appeal.notify_appeal'),
              isGroupping: true,
              inGroup: {
                enableSend: { value: 'enableSend', text: this.$t('appeal.can_send_appeal') },
                enableEdit: { value: 'enableEdit', text: this.$t('task.can_approve_cancel_edit_appeal') },
              },
              groups: {

              }
            },
          }
        }
      }
      res.appeal.value.enableViewAppeal.groups = {}
      for (const key in this.AppealLabels.subCategory)
        res.appeal.value.enableViewAppeal.groups[key] = { value: key, text: this.$t(`appeal_data.subCategory.${this.AppealLabels.subCategory[key].value}`) }
      return res
    }
  },
  data() {
    return {
      AppealLabels,
      isLoading: false,
      formData: {},

    };
  },
  watch: {
    value(newv) {
      if (newv) this.initData();
    }
  },
  methods: {
    async initData() {
      this.formData = {
        id: undefined,
        enableViewAreas: false,
        enableViewCustomers: false,
        enableViewAreaInterests: false,
        enableViewBilling: false,
        enableViewAccounting: false,
        enableViewReports: false,
        enableViewIncomeExpense: false,
        enableViewOverall: false,

        enableCannotCheckOut: false,
        enableEditInvoiceAndReceipt: false,
        enableAddAccountingProduct: false,
        enableAddProduct: false,
        enableEditTaxId: false,
        enableViewBoard: false,

        enableViewAccountingProject: false,
        enableViewReportsProject: false,

        enableViewSettings: false,
        enableEditBillingSetting: false,
        enableEditAreaAccountingProduct: false,
        enableSendApproveBillingSetting: false,

        enableViewApprove: false,
        enableApproveAreaInterest: false,
        enableApproveSettingBilling: false,
        enableApproveSettingAreaAccounting: false,
        enableApproveCheckout: false,

        enableViewAppeal: false,
        enableAppealObject: {},
      };
      if (this.employee) {
        this.formData = {
          id: this.employee.objectId,

          enableViewAreas: this.employee.enableViewAreas,
          enableViewCustomers: this.employee.enableViewCustomers,
          enableViewAreaInterests: this.employee.enableViewAreaInterests,
          enableViewBilling: this.employee.enableViewBilling,
          enableViewAccounting: this.employee.enableViewAccounting,
          enableViewReports: this.employee.enableViewReports,
          enableViewIncomeExpense: this.employee.enableViewIncomeExpense,
          enableViewOverall: this.employee.enableViewOverall,

          enableCannotCheckOut: this.employee.enableCannotCheckOut,
          enableEditInvoiceAndReceipt: this.employee.enableEditInvoiceAndReceipt,
          enableAddAccountingProduct: this.employee.enableAddAccountingProduct,
          enableAddProduct: this.employee.enableAddProduct,
          enableEditTaxId: this.employee.enableEditTaxId,
          enableViewBoard: this.employee.enableViewBoard,
          enableDigitalMeterOnOff: this.employee.enableDigitalMeterOnOff,
          enableDigitalMeterReset: this.employee.enableDigitalMeterReset,

          enableViewAccountingProject: this.employee.enableViewAccountingProject,
          enableViewReportsProject: this.employee.enableViewReportsProject,

          enableViewSettings: this.employee.enableViewSettings,
          enableEditBillingSetting: this.employee.enableEditBillingSetting,
          enableEditAreaAccountingProduct: this.employee.enableEditAreaAccountingProduct,
          enableSendApproveBillingSetting: this.employee.enableSendApproveBillingSetting,

          enableViewApprove: this.employee.enableViewApprove,
          enableApproveAreaInterest: this.employee.enableApproveAreaInterest,
          enableApproveSettingBilling: this.employee.enableApproveSettingBilling,
          enableApproveSettingAreaAccounting: this.employee.enableApproveSettingAreaAccounting,
          enableApproveCheckout: this.employee.enableApproveCheckout,

          enableViewAppeal: this.employee.enableViewAppeal,
          enableAppealObject: this.employee.enableAppealObject,
        };
      }
      if (!this.formData.enableAppealObject) {
        this.formData.enableAppealObject = {};
        for (const key in this.AppealLabels.subCategory) {
          if (!this.formData.enableAppealObject[key]) {
            this.formData.enableAppealObject[key] = {
              enableSend: true,
              enableEdit: true
            };
          }
        }
      } else {
        for (const key in this.AppealLabels.subCategory) {
          if (!this.formData.enableAppealObject[key]) {
            this.formData.enableAppealObject[key] = {
              enableSend: false,
              enableEdit: false
            };
          }
        }
      }
    },
    submit() {
      if (!this.formData.enableViewAppeal)
        this.formData.enableAppealObject = {};
      this.$emit("onSuccess", this.formData);
      this.$emit("input", false);
    },
    dismiss() {
      this.$emit("input", false);
    },
    changeEnable(mode, value, isAll = false) {
      if (mode == 'enableViewSettings') {
        if (!value) {
          this.formData.enableEditBillingSetting = false;
          this.formData.enableEditAreaAccountingProduct = false;
          this.formData.enableSendApproveBillingSetting = false;
        } else if (isAll) {
          this.formData.enableEditBillingSetting = true;
          this.formData.enableEditAreaAccountingProduct = true;
          this.formData.enableSendApproveBillingSetting = true;
        }
      } else if (mode == 'enableViewApprove') {
        if (!value) {
          this.formData.enableApproveAreaInterest = false;
          this.formData.enableApproveSettingBilling = false;
          this.formData.enableApproveSettingAreaAccounting = false;
          this.formData.enableApproveCheckout = false;
        } else if (isAll) {
          this.formData.enableApproveAreaInterest = true;
          this.formData.enableApproveSettingBilling = true;
          this.formData.enableApproveSettingAreaAccounting = true;
          this.formData.enableApproveCheckout = true;
        }
      } else if (mode == 'enableViewAppeal') {
        if (!value) {
          for (const key in this.AppealLabels.subCategory) {
            this.formData.enableAppealObject[key] = {
              enableSend: false,
              enableEdit: false
            };
          }
        } else if (value && isAll) {
          for (const key in this.AppealLabels.subCategory) {
            this.formData.enableAppealObject[key] = {
              enableSend: true,
              enableEdit: true
            };
          }
          this.$forceUpdate();
        }
      }
    },

  }
};
</script>

<style lang="scss" scoped>
div .v-icon {
  margin-right: 5px;
}

// .group-items::v-deep {
//   margin-top: 15px;

//   .v-list-group__header,
//   .v-list-item {
//     padding: 0 !important;
//   }

//   .theme--light.v-list-item--active:hover::before,
//   .theme--light.v-list-item--active::before,
//   .theme--light.v-list-item:focus::before,
//   .theme--light.v-list-item--active:focus::before,
//   .theme--light.v-list-item:hover::before {
//     opacity: 0;
//   }

//   .div-items {
//     .header {
//       font-size: 17px;
//       margin-top: 15px;
//     }

//     .v-input--checkbox {
//       margin-top: 5px;
//     }
//   }
// }

.group {
  // padding: 10px 0;

  .group-box {
    position: relative;
    border: 1px dashed rgb(219, 219, 219);
    border-radius: 5px;
    padding: 10px;
    margin: 25px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    .group-header {
      position: absolute;
      top: -12px;
      left: 10px;
      font-size: 15px;
      // margin-top: -20px;
      background: #fff;
      width: fit-content;
      padding: 0 10px;
      color: rgb(182, 182, 182);
    }

    .group-data {
      display: flex;
      flex-wrap: wrap;

      .v-input {
        margin-top: 5px;
      }

      .group-items {
        display: flex;
        flex-wrap: wrap;

        // width: 100%;
        .group-item {
          // margin-top: 15px;
          margin-left: 10px;
          min-width: 150px;

          .in-group-item {

            .in-group-item-header {
              font-size: 15px;
              margin-top: 15px;
              font-weight: bold;
            }
          }
        }

        .item-header {
          display: flex;
          flex-wrap: wrap;
          align-content: space-between;
          width: 150px;

          .v-input {
            width: 100%;
          }

          .v-btn {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>